module.exports = __webpack_public_path__ + "img/logo-government-3.e0147d48.png";